import dayjs from 'dayjs';

/**
 * 将日期格式化为中文年月日格式
 * @param {Date|string|number} date - 日期值（支持 Date 对象、时间戳、ISO 字符串）
 * @param {Object} [options] - 格式化选项
 * @param {string} [options.format='YYYY年MM月DD日'] - 自定义格式模板
 * @param {boolean} [options.utc=false] - 是否使用 UTC 时间
 * @param {boolean} [options.trimZero=false] - 是否去除月份/日期的前导零
 * @returns {string} 格式化后的日期字符串
 */
export const formatDate = (date, options = {}) => {
  const { format = 'YYYY-MM-DD', utc = false, trimZero = false } = options;

  // 处理空值情况
  if (!date) return '';

  let dayjsDate;
  try {
    // 创建 dayjs 对象
    dayjsDate = dayjs(date);

    // 处理无效日期
    if (!dayjsDate.isValid()) {
      console.warn('Invalid date:', date);
      return '';
    }

    // UTC 转换
    if (utc) dayjsDate = dayjsDate.utc();

    // 应用最终格式（根据 trimZero 选项调整格式）
    const finalFormat = trimZero ? format.replace('MM', 'M').replace('DD', 'D') : format;

    return dayjsDate.format(finalFormat);
  } catch (error) {
    console.error('Date formatting failed:', error);
    return '';
  }
};

/* 使用示例：
// 1. 基本用法
formatDate(new Date()); // "2023年08月25日"

// 2. 去除前导零
formatDate('2023-01-01', { trimZero: true }); // "2023年1月1日"

// 3. 使用UTC时间
formatDate(Date.now(), { utc: true }); // UTC时间的年月日

// 4. 自定义格式
formatDate(new Date(), { format: 'YYYY/MM/DD' }); // "2023/08/25"
*/
